import { Injectable } from "@angular/core";

@Injectable({ providedIn: "root" })

export class InstitutionConstants {
  jsonSectionIds = {
    KeyDetails: 1,
    AboutInstitution: 2,
    SchoolInformation: 3,
    Facilities: 4,
    Flags: 5,
    Clearing: 6,
    KeyUrls: 7,
    Rankings: 8,
    Legacy: 9,
    StudyBC: 10
  };

  flagTypes = {
    contractFlag: 'Contract Flag',
    businessFlag: 'Business Flag',
    displayFlag: 'Display Flag'
  }

  refMapping: any = {
    // Section 1
    'institutionCountryId': 'country',
    'institutiongroupIds': 'institutionGroupType',
    'institutionCodeTypeId': 'institutionCodeType',
    // Section 2
    'institutionTypeId': 'institutionType',
    'institutionLocationTypeId': 'institutionLocationType',
    // Section 3
    'schoolTypeId': 'schoolType',
    'religiousAffiliationId': 'religiousAffiliation',
    'schoolEducationLevelId': 'schoolQualificationLevel',
    'schoolYearsOfferedId': 'schoolYearsOffered',
    'genderMixId': 'institutionGenderMix',
    // Section 4
    'facilityTypeId': 'facilityType',
    // Section 5
    'institutionChannels': 'channel'
  };

  multiSelectFields: any[] = ['institutiongroupIds', 'facilityTypeId', 'schoolYearsOfferedId'];

  // hardcoded ref value
  institutionTypeIdForSchool = 5;

  ukSpecificFields: any[] = ['tefRating', 'clearingAccommodationAvailable', 'clearingScholarshipAvailable'];
  clearingProviderFields: any[] = ['clearingAccommodationAvailable', 'clearingScholarshipAvailable'];
  roleBasedRestrict: any[] = ['Data Analyst', 'Data Validator'];
  ckEditorFields = ['internationalStudentBreakdown', 'profileSummary', 'recognizedAreaStudy']
  institutionAttributeIds: any = {
    'applicableToStudyBC': 100,
    'bcPostCode': 96,
    'domainEmail': 91
  }

  studyBCContractFlagId = 28;
  idpClientFlagId = 50;
  oipFlagIds = [51, 66, 67];
  advertFlagIds = [37, 38];
  clearingProviderFlagId = 34;
  ucasProviderFlagId = 78;
  manualApplicationFlagId = 91;

  calFeeAttributeIds = [104, 105];
  rankingCategoryRefId = "rankingCategory";
  rankingFieldId = "ranking";
  rankingYearFieldId = "rankingYear";
  rankingPositionFieldValidation = /[^0-9\+\-]*/g;
  
  domainEmailAttrName = 'domEmail';
  manualApplnFlagHelpText = 'Enable this flag to keep manual application institutions available for internal systems while hiding them from external student/client-facing platforms.'
}
